const initialState = {
  outOfHours: false,
};

export default function getInTouch(state = initialState, action) {
  switch (action.type) {
    default:
      return state;
  }
}
